
import React from "react";
import { PartFilter } from "@/data/parts";
import { FilterBadge } from "@/components/shared";
import { Settings, Printer, ShoppingCart, Wrench, Zap } from "lucide-react";

interface RequirementsFilterBadgesProps {
  activeFilters: PartFilter[];
  toggleFilter: (filter: PartFilter) => void;
}

const RequirementsFilterBadges = ({ 
  activeFilters, 
  toggleFilter 
}: RequirementsFilterBadgesProps) => {
  const requirements = [
    {
      filter: "requires-root" as PartFilter,
      icon: <Settings size={14} />,
      activeLabel: "Root",
      inactiveLabel: "No Root",
      type: "root" as const,
      tooltip: "Toggle root access requirement filter"
    },
    {
      filter: "requires-tools" as PartFilter,
      icon: <Wrench size={14} />,
      activeLabel: "Tools",
      inactiveLabel: "No Tools",
      type: "tools" as const,
      tooltip: "Toggle tools requirement filter"
    },
    {
      filter: "wiring" as PartFilter,
      icon: <Zap size={14} />,
      activeLabel: "Wiring",
      inactiveLabel: "No Wiring",
      type: "wiring" as const,
      tooltip: "Toggle wiring requirement filter"
    },
    {
      filter: "requires-printing" as PartFilter,
      icon: <Printer size={14} />,
      activeLabel: "Print",
      inactiveLabel: "No Print",
      type: "printing" as const,
      tooltip: "Toggle printing requirement filter"
    },
    {
      filter: "requires-purchase" as PartFilter,
      icon: <ShoppingCart size={14} />,
      activeLabel: "Purchase",
      inactiveLabel: "No Purchase",
      type: "purchase" as const,
      tooltip: "Toggle purchase requirement filter"
    }
  ];

  return (
    <div className="grid grid-cols-2 gap-2 px-2">
      {requirements.map(({ filter, icon, activeLabel, inactiveLabel, type, tooltip }) => {
        const isActive = activeFilters.includes(filter);
        const label = isActive ? inactiveLabel : activeLabel;
        
        return (
          <FilterBadge
            key={filter}
            type={type}
            icon={icon}
            active={!isActive}
            showStrikethrough={isActive}
            tooltip={tooltip}
            onClick={() => toggleFilter(filter)}
            className="w-full justify-start bg-transparent border-0"
            aria-label={`${isActive ? 'Hide' : 'Show'} ${activeLabel.toLowerCase()} requirements`}
          >
            {label}
          </FilterBadge>
        );
      })}
    </div>
  );
};

export default RequirementsFilterBadges;
